export default __webpack_public_path__ + "static/media/dev-icon.2bb4313e.svg";